/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".heading[_ngcontent-%COMP%]{width:100%;margin-bottom:10px;font-size:20px}#h3[_ngcontent-%COMP%], .heading[_ngcontent-%COMP%]{background-color:#004aad;color:#fff}#h3[_ngcontent-%COMP%]{display:inline}#h3[_ngcontent-%COMP%], body[_ngcontent-%COMP%], html[_ngcontent-%COMP%]{font-family:Montserrat,sans-serif!important}"];
export { styles as styles };

